<template>
  <div class="messageDetail">
    <div class="navbar">
      <span>预约须知</span>
      <img src="@/assets/images/detail/back.png" alt="" class="back" @click="back" />
    </div>
    <div class="message_content">
      <div class="content" v-html="detailInfo.knowContent"></div>
    </div>
  </div>
</template>
<script>
import { getKnowContent, getKnowContentSite } from '@/api/venue.js'
export default {
  name: 'messageDetail',
  data() {
    return {
      detailInfo: {},
      type: '',
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    getDetail() {
      if (this.type == 0) {
        getKnowContent({ venueId: this.id }).then((res) => {
          this.detailInfo = res.result
        })
      } else {
        getKnowContentSite({ siteId: this.id }).then((res) => {
          this.detailInfo = res.result
        })
      }
    },
  },
  mounted() {
    const { id, type } = this.$route.query
    this.id = id
    this.type = type
    this.getDetail()
  },
}
</script>
<style lang="scss" scoped>
.messageDetail {
  width: 100%;
  height: 100vh;
  background: #fff;
  .navbar {
    z-index: 9999;
    width: 100%;
    height: 44px;
    position: fixed;
    top: 40px;
    // top: calc(40px + env(safe-area-inset-top));
    left: 0;
    text-align: center;
    line-height: 44px;
    font-weight: 600;
    color: #112a26;
    font-size: 0.9rem;
    background: #fff;
    .back {
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 0.5rem;
    }
  }
  .message_content {
    padding: 0.2rem 0.6rem 0 0.6rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    width: 100%;
    // height: calc(100% - 84px - env(safe-area-inset-top));
    height: calc(100% - 84px);
    position: absolute;
    // top: calc(84px + env(safe-area-inset-top));
    top: 84px;
    left: 0;
    overflow-y: auto;
  }
  .message_title {
    font-size: 0.9rem;
    font-weight: 600;
    color: #212121;
    line-height: 1.4rem;
    margin-bottom: 0.4rem;
  }
  .sub_title {
    font-size: 0.6rem;
    color: #666666;
    line-height: 0.8rem;
    padding-bottom: 0.6rem;
    border-bottom: 1px solid #f4f4f4;
    margin-bottom: 0.6rem;
  }
  .content {
    font-size: 0.7rem;
    color: #666666;
    line-height: 1rem;
    img {
      width: 100%;
      height: 9.7rem;
      margin: 0.8rem 0;
      border-radius: 0.5rem;
    }
  }
}
</style>
